import { getRequest } from '@/utils/http'

export async function getTags (params) {
  return getRequest('/official/tags', params)
}

export async function getTeacherTags (params) {
  return getRequest('/teacher/tags', params)
}
